import { StylesConfig } from 'react-select';
import { ListItem } from './types';
import { APP_COLORS, Colors } from 'design-v2/globals/colors/colors';

export function getReactSelectStyles(centerList: boolean, largeFont = false, isFloorPlanDesign = false): StylesConfig<ListItem> {
  return {
    menu: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '0 0 5px 5px',
      transform: centerList ? 'translateY(-50%)' : 'none',
      width: "auto",
      minWidth: '155px',
    }),
    menuList: (provided: any, state: any) => ({
      ...provided,
      maxHeight: 500,
      fontWeight: '1.8rem'
    }),
    menuPortal: (provided: any, state: any) => ({
      ...provided,
      zIndex: 500,
    }),
    valueContainer: (provided: any, state: any) => ({
      ...provided,
      textAlign: `left`,
      // padding: '2px 0'
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      background: `${isFloorPlanDesign ? '#333 !important' : 'transparent'}`,
      border: `${isFloorPlanDesign ? `1px solid #666 !important` : `1px solid ${Colors.get(APP_COLORS.clrGreyLight)}`}`,
      boxShadow: 'none', // for focus outline
      cursor: 'pointer',
      minHeight: 35,
      height: '100%',
      '&:hover': {
        border: `${isFloorPlanDesign ? '1px solid #666 !important' : `1px solid ${Colors.get(APP_COLORS.clrGreyLight)}`}`,
        backgroundColor: `${isFloorPlanDesign ? '#434343 !important' : 'transparent'}`,
      },
      '&:active': {
        border: `${isFloorPlanDesign ? '1px solid #666 !important' : `1px solid ${Colors.get(APP_COLORS.clrGreyLight)}`}`,
        backgroundColor: `${isFloorPlanDesign ? '#616161 !important' : 'transparent'}`,
      }
    }),
    container: (provided: any, state: any) => ({
      ...provided,
      width: '100%',
      height: '100%',
      // padding: 0
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      background: 'transparent !important',
      padding: 0,
      '&:hover': {
        background: `${isFloorPlanDesign ?  `${Colors.get(APP_COLORS.clrGreyLight)}!important`: 'transparent !important'}`,
      }

    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      color: `${isFloorPlanDesign ? '#fff !important' : '#666 !important'}`,
    }),
    indicatorSeparator: (provided: any, state: any) => ({
      ...provided,
      color: `${isFloorPlanDesign ? '#fff !important' : '#666 !important'}`,
    }),
    indicatorsContainer: (provided: any, state: any) => ({
      ...provided,
      padding: '0 8px',
      color: `${Colors.get(APP_COLORS.clrNbiMagenta)} !important`,
    }),
    placeholder: (provided: any, state: any) => ({
      ...provided,
      color: `${isFloorPlanDesign ? '#fff !important' : '#666 !important'}`,
      fontSize: `${largeFont ? '1.6rem' : '1.2rem'}`,
    }),
  };
}
